import { Box, Button, HStack, Icon, SearchInput, Text } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { OrderByDropdown } from '../../../../../../components/OrderByDropdown';
import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import {
  fixedFeeTermsFiltersAtom,
  fixedFeeTermsOrderByAtom,
} from '../../../../../../store/fixedFee/atom';
import { fixedFeeSearchPlaceholder } from '../../constants';

import { FixedFeeTermsHeaderProps } from '.';

export const FixedFeeTermsHeaderTablet: React.FC<FixedFeeTermsHeaderProps> = ({
  onSearch,
  onClearSearch,
  onRefresh,
  disabled,
}) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { appliedFilters } = useRecoilValue(fixedFeeTermsFiltersAtom);

  return (
    <HStack
      p="inline.xxs"
      pb={0}
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      space="stack.xxxs">
      <SearchInput
        onSearch={onSearch}
        onClear={onClearSearch}
        placeholder={fixedFeeSearchPlaceholder}
        isLoading={disabled}
      />

      <HStack alignItems="center" space="inline.nano" flexWrap="wrap">
        <Button
          variant="secondary"
          onPress={onRefresh}
          paddingBottom="stack.xxxs"
          paddingTop="stack.xxxs"
          paddingLeft="inline.xxxs"
          paddingRight="inline.xxxs"
          h={undefined}
          isDisabled={disabled}
          _text={{ textTransform: 'none' }}>
          <Icon name="Refresh" size="xxxs" color="neutral.black" />
        </Button>

        {!disabled && (
          <OrderByDropdown
            extraCustomBoxProps={{ paddingLeft: 0, paddingRight: 0, p: 0 }}
            triggerLabel=""
            orderByAtom={fixedFeeTermsOrderByAtom}
          />
        )}

        <Button
          variant="secondary"
          onPress={() => navigate('FixedFeeReportModal')}
          paddingBottom="stack.xxxs"
          paddingTop="stack.xxxs"
          paddingLeft="inline.xxxs"
          paddingRight="inline.xxxs"
          h={undefined}
          isDisabled={disabled}
          _text={{ textTransform: 'none' }}>
          <Icon name="FileExe" size="xxxs" color="neutral.black" />
        </Button>

        <Button
          variant="secondary"
          onPress={() => navigate('FixedFeeFilterModal')}
          _text={{ textTransform: 'none' }}
          paddingLeft="inline.xxxs"
          paddingRight="inline.xxxs"
          h={undefined}
          isDisabled={disabled}
          {...(!appliedFilters.length && {
            rightIcon: <Icon name="Funnel" size="xxxs" color="neutral.black" />,
          })}>
          <HStack alignItems="center" justifyContent="center" space="inline.nano">
            <Text variant="semibold" fontSize="md" color="neutral.black">
              Filtrar
            </Text>
            {!!appliedFilters.length && (
              <Box
                borderRadius="full"
                w="20px"
                h="20px"
                alignItems="center"
                justifyContent="center"
                bg="brand.tertiary.light">
                <Text variant="regular" fontSize="xs" color="neutral.white">
                  {appliedFilters.length}
                </Text>
              </Box>
            )}
          </HStack>
        </Button>
      </HStack>
    </HStack>
  );
};
